export default new Map<string, string>([['0,2', 'da-privati']]);
